// Security utilities for frontend protection
import { useState } from 'react';

// Input sanitization to prevent XSS
export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return '';
  
  return input
    .trim()
    .replace(/[<>]/g, '') // Remove potential HTML tags
    .replace(/javascript:/gi, '') // Remove javascript: protocol
    .replace(/on\w+=/gi, '') // Remove event handlers
    .substring(0, 1000); // Limit length
};

// Enhanced email validation
// export const validateEmail = (email) => {
//   // Basic format check
//   const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//   if (!emailRegex.test(email)) return false;
  
//   // Length check (RFC 5321 limit)
//   if (email.length > 254) return false;
  
//   // Local part length check (before @)
//   const localPart = email.split('@')[0];
//   if (localPart.length > 64) return false;
  
//   // No consecutive dots
//   if (email.includes('..')) return false;
  
//   return true;
// };

export const validateEmail = (email) => {
  // Basic format check
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(email)) return false;

  // Length check (RFC 5321 limit)
  if (email.length > 254) return false;

  // Local part length check (before @)
  const localPart = email.split('@')[0];
  if (localPart.length > 64) return false;

  // No consecutive dots
  if (email.includes('..')) return false;

  return true;
};

// Name validation
// export const validateName = (name) => {
//   if (!name || name.trim().length < 2) return false;
//   if (name.length > 100) return false;
//   if (!/^[a-zA-Z\s]+$/.test(name)) return false;
//   return true;
// };

export const validateName = (name) => {
  // if (!name || name.trim().length < 2) return false;
  if (!name || name.length < 2) return false;
  if (name.length > 100) return false;
  if (!/^[a-zA-Z0-9\s]+$/.test(name)) return false; // allows letters, numbers, and spaces
  return true;
};

// Rate limiting hook
export const useRateLimit = (maxAttempts = 3, windowMs = 60000) => {
  const [attempts, setAttempts] = useState([]);
  
  const canSubmit = () => {
    const now = Date.now();
    const recentAttempts = attempts.filter(time => now - time < windowMs);
    return recentAttempts.length < maxAttempts;
  };
  
  const recordAttempt = () => {
    setAttempts(prev => [...prev, Date.now()]);
  };
  
  return { canSubmit, recordAttempt };
};

// Security monitoring
// export const SecurityMonitor = {
//   trackEvent: (eventType, details) => {
//     const event = {
//       type: eventType,
//       timestamp: Date.now(),
//       userAgent: navigator.userAgent,
//       url: window.location.href,
//       details
//     };
    
//     // Log security events (in production, send to monitoring service)
//     console.log('Security Event:', event);
//   },
  
//   trackFailedLogin: (email) => {
//     SecurityMonitor.trackEvent('FAILED_LOGIN', { email });
//   },
  
//   trackFormTampering: (formName) => {
//     SecurityMonitor.trackEvent('FORM_TAMPERING', { formName });
//   },
  
//   trackRateLimitExceeded: (form) => {
//     SecurityMonitor.trackEvent('RATE_LIMIT_EXCEEDED', { form });
//   }
// };

// Check if running on HTTPS
export const isSecureContext = () => {
  return window.isSecureContext || window.location.protocol === 'https:';
};

// Secure API call helper
export const secureApiCall = async (url, options = {}) => {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest', // CSRF protection
    },
    credentials: 'same-origin', // Include cookies for same-origin requests
  };
  
  // Add CSRF token if available
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
  if (csrfToken) {
    defaultOptions.headers['X-CSRF-Token'] = csrfToken;
  }
  
  const response = await fetch(url, { ...defaultOptions, ...options });
  
  // Check for security headers
  const cspHeader = response.headers.get('Content-Security-Policy');
  if (!cspHeader) {
    console.warn('Missing CSP header');
  }
  
  return response;
};

// Safe error message handler
export const handleApiError = (error) => {
  // Generic error messages for users
  const userFriendlyMessages = {
    'INVALID_CREDENTIALS': 'Invalid email or password',
    'ACCOUNT_LOCKED': 'Account temporarily locked',
    'NETWORK_ERROR': 'Connection error. Please try again.',
    'VALIDATION_ERROR': 'Please check your input and try again'
  };
  
  // Log detailed errors for debugging (not shown to user)
  console.error('API Error:', error);
  
  // Show safe message to user
  return userFriendlyMessages[error.code] || 'An error occurred. Please try again.';
};
